var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},[(_vm.status === 1)?_c('span',{staticClass:"status-enabled"},[_vm._v(" "+_vm._s(_vm.$t('application_table_status_enable'))+" ")]):_c('span',{staticClass:"status-disabled"},[_vm._v(" "+_vm._s(_vm.$t('application_table_status_disable'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }